(() => {
  const script = document.currentScript;
  if (!script || document.body.classList.contains('template-product')) return;
  const poses = [script.dataset.lounge, script.dataset.reach];
  const enhance = (root) => {
    root.querySelectorAll('#MainContent h1, #MainContent .rte h2').forEach((heading, index) => {
      if (heading.closest('.zs-heading, .zw, form, .zp-pcard')) return;
      const wrapper = document.createElement('div');
      const right = index % 2 === 1;
      wrapper.className = `zs-heading zs-heading--${right ? 'right' : 'left'} zs-heading--${right ? 'reach' : 'lounge'}${heading.tagName === 'H1' ? ' zs-heading--hero' : ''}`;
      const words = document.createElement('span');
      words.className = 'zs-heading__words';
      heading.textContent.trim().split(/\s+/).forEach((word, i) => {
        if (i) words.append(' ');
        const part = document.createElement('span');
        part.className = 'zs-heading__word';
        part.textContent = word;
        words.append(part);
      });
      heading.replaceChildren(words);
      heading.classList.add('zs-heading__text');
      heading.removeAttribute('style');
      heading.before(wrapper);
      wrapper.append(heading);
      const ster = document.createElement('img');
      ster.src = poses[right ? 1 : 0];
      ster.alt = '';
      ster.setAttribute('aria-hidden', 'true');
      ster.loading = 'lazy';
      ster.className = 'zs-heading__ster';
      wrapper.append(ster);
    });
  };
  const fitTitles = () => {
    document.querySelectorAll('.zs-heading__text').forEach((heading) => {
      heading.style.fontSize = '';
      const style = getComputedStyle(heading);
      const available = heading.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const words = [...heading.querySelectorAll('.zs-heading__word')];
      const widest = Math.max(0, ...words.map((word) => word.getBoundingClientRect().width));
      if (available > 0 && widest > available) {
        heading.style.fontSize = `${parseFloat(style.fontSize) * available / widest * 0.98}px`;
      }
    });
  };
  enhance(document);
  fitTitles();
  document.fonts.ready.then(fitTitles);
  window.addEventListener('resize', fitTitles);
  document.addEventListener('shopify:section:load', () => { enhance(document); fitTitles(); });
})();
